import React, { useEffect, useState } from "react";
import { FaRegDotCircle, FaSpinner } from "react-icons/fa";
import DeliveryStatus from "./DeliveryStatus.jsx"
import OrderCompletePopup from "./OrderCompletePopup.jsx"
import { useDispatch, useSelector } from "react-redux";
import OrderStatusHistory from "./OrderStatusHistory.jsx";
import RecieptPopup from "./RecieptPopup.jsx";
import Delivery2 from "../../../assets/pickuplog.png";
import { Link, useParams } from "react-router-dom";
import api from "../../../utils/api.js";
import GoogleMapsOrderStatus from "../Summary/LocationInput.jsx";

const OrderStatus = () => {
  const { id } = useParams(); // Get the orderId from the URL
  const [orderData, setOrderData] = useState(null);
 
  const [loading, setLoading] = useState(true); // Add loading state
  const { user } = useSelector((state) => state.user);
  const [isReceiptPopupOpen, setIsReceiptPopupOpen] = useState(true);
  const [isOrderCompletePopupOpen, setIsOrderCompletePopupOpen] = useState(false);
  const handleReceiptClosed = () => {
    setIsReceiptPopupOpen(false);
    setIsOrderCompletePopupOpen(true);
  };
  useEffect(() => {
    const fetchOrderData = async () => {
      setLoading(true)
      try {
        const response = await api.get(`/order/${id}`);
        setOrderData(response?.data);
        console.log("🚀 ~ fetchOrderData ~ response:", response);
      } catch (error) {
        console.log("Error fetching order:", error);
      } finally {
        setLoading(false); // Set loading to false once data is fetched
      }
    };

    fetchOrderData();
  }, [id]);
  const shouldShowMarketFee =
  orderData?.data?.marketPlaceFee &&
  ((orderData?.data?.orderType === "delivery" && orderData?.data.marketPlaceFee.delivery) ||
    (orderData?.data?.orderType === "pickup" && orderData?.data.marketPlaceFee.pickup));
  return (
    <>
    {loading ? (
       <div className="flex justify-center items-center min-h-screen">
       <FaSpinner className="animate-spin text-4xl text-[#C97C2A]" />
     </div>
    ): (
      <>
      <section className="flex flex-col justify-center items-center px-16 py-6 lg:h-[142px] md:h-[100.98px] overflow-x-hidden h-[81px] sm:h-[81px]  w-full text-6xl font-bold tracking-wide text-center text-white bg-amber-600 max-md:px-5 max-md:max-w-full max-md:text-4xl">
        <div className="flex gap-6 justify-between items-center  max-md:text-4xl">
          <h1 className=" lg:text-[60px] text-[28.44px] sm:text-[28.44px] md:text-[36.75px]">
            Order Status
          </h1>
        </div>
      </section>
      <div className="mt-8 flex justify-between lg:w-[310px] lg:h-[95px] w-[114.11px] h-[35.75px] sm:w-[114.11px] sm:h-[35.75px] md:w-[206.49px] md:h-[68.04px] bg-[#AF313D] rounded-full mx-auto mb-6 items-center">
        <div className="lg:w-[280px] lg:h-[83px] w-[104.11px] h-[30.75px] sm:w-[104.11px] sm:h-[30.75px] md:w-[196.49px] md:h-[58.04px] mx-auto   bg-white flex gap-4 items-center justify-center rounded-full">
          <img
            src={Delivery2}
            className=" lg:w-[53px] lg:h-[53px] w-[19.64px] h-[19.64px] sm:w-[19.64px] sm:h-[19.64px] md:w-[37.06px] md:h-[37.06px]"
            alt=""
          />
          <h1 className=" font-baloo font-bold lg:text-[30px] md:text-[20.98px] text-[11.11px] sm:text-[11.11px] text-[#000000]  lg:tracking-[.1rem] capitalize">
            {orderData?.data?.orderType}
          </h1>
        </div>
      </div>
     
      <div className=" mt-2  mb-4">
        <div className=" bg-gray-50 w-[90%] mx-auto shadow-lg">
          <div className="flex flex-col gap-6">
            <div className=" text-[#AF313D] flex items-center justify-center font-baloo font-bold text-[18.21px] sm:text-[18.21px] lg:leading-[96.12px] lg:text-[60px] md:text-[41.92px] ">
              Order Status
            </div>
            <div className="flex justify-between px-8 font-baloo font-medium sm:text-[15.17px] text-[15.17px] lg:text-[50px] md:text-[34.94px]">
              <h1>Order ID</h1>
              <h1>{orderData?.data?._id.slice(-6)}</h1>
            </div>
            <div className=" w-full bg-[#AF313D] lg:h-[115px] md:h-[80.36px] h-[34.9px] sm:h-[34.9px] font-baloo lg:font-semibold text-[18.21px] sm:text-[18.21px] text-white flex items-center justify-center md:text-[41.92px] lg:text-[50px]">
              <button>
                {orderData?.data.orderStatus === "cancelled"? "Cancelled": "Your Order In Preparation"}
              </button>
            </div>
            <div className="flex items-center justify-between px-8 mb-4 sm:w-[90%] gap-4 w-[90%] lg:w-[90%] md:w-[100%]">
              <div className=" font-baloo font-semibold lg:text-[40px] text-[12.14px] md:text-[27.95px] sm:text-[12.14px]">
                <h1>Estimated Time</h1>
              </div>
              <div className="flex-1 gap-4 flex flex-col relative sm:max-w-[167.22px] max-w-[167.22px] md:max-w-[385.01px] lg:max-w-[451px]">
                <label className="relative w-full ">
                  <input
                    type="radio"
                    name="paymentMethod"
                    value="stripe"
                    className="hidden"
                  />
                  <div className="flex items-center gap-2 w-full p-2 pl-6 border  border-gray-300   hover:border-blue-500 transition duration-200">
                    <FaRegDotCircle className="text-[#000000]" />

                    <span className="lg:text-[24.99px] md:text-[16.18px] text-[9.28px] sm:text-[9.28px] text-[#515978] font-baloo font-medium">
                    {orderData?.data?.estimatedTime || "Standard ( 15-30min )"}
                    </span>
                  </div>
                </label>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <DeliveryStatus estimatedTime={orderData?.data?.estimatedTime} orderData={orderData} status={orderData?.status} />

      <div className=" mt-2  mb-4">
        <div className=" bg-gray-50 w-[90%] mx-auto shadow-sm">
          <OrderStatusHistory orderData={orderData} />
        </div>
      </div>
   {orderData?.data?.orderType === "delivery" && (
       <GoogleMapsOrderStatus restaurantAddress={ orderData?.data?.restaurantAddress} userAddress={orderData?.data?.userAddress}/>
   )}
      <div className="flex flex-col items-center justify-center mb-9 ">
       <Link to="/contact">
       <div className="flex  items-center justify-center">
          <button className="bg-[#AF313D] text-[12.08px] sm:text-[12.08px]  w-[119.86px] h-[34.84px] sm:w-[119.86px] sm:h-[34.84px] lg:text-[38.9px] md:text-[27.18px] text-white font-baloo md:font-semibold md:w-[269.71px] md:h-[78.41px] lg:w-[386px] lg:h-[112.21px] rounded-full ">Contact Support</button>
        </div>
       </Link>
        <div className="sm:text-[9.94px] text-[9.94px] md:text-[22.36px] lg:text-[32px] font-baloo font-medium text-[#444444] mt-3 sm:mt-3 md:mt-6">
          <h1>If you are facing problems in order process contact us</h1>
        </div>
      </div>

      <div>
      {isReceiptPopupOpen && !isOrderCompletePopupOpen && (
        !loading && orderData && (
          <RecieptPopup 
          closePopup={handleReceiptClosed}
          orderData={orderData?.data} />
        )
      )}

      {isOrderCompletePopupOpen && (
        <OrderCompletePopup 
        orderData={orderData} />
      )}
    </div>
      
      </>
    )}
      
    </>
  );
};

export default OrderStatus;
